import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { TenantConfigService } from "../../types/tenantConfig";
import UnavailableServiceRedirect from "./UnavailableServiceRedirect";

interface RequireServiceProps {
  service: TenantConfigService;
  children: React.ReactElement;
}

/**
 * Route-element guard: renders `children` only when the active tenant's
 * `services` allow-list includes `service`; otherwise falls back to
 * UnavailableServiceRedirect.
 *
 * UnavailableServiceRedirect waits for `configLoaded === true` before it
 * redirects, so a direct-paste URL that lands here before the async tenant
 * load resolves shows a loader (not a wrongful redirect based on the default
 * services list). Once loadTenantConfig resolves this guard re-evaluates and
 * either keeps rendering the redirect or swaps in `children`.
 */
const RequireService: React.FC<RequireServiceProps> = ({
  service,
  children,
}) => {
  const services = useSelector(
    (state: RootState) => state.tenantConfig.config.services
  );

  return services?.includes(service) ? (
    children
  ) : (
    <UnavailableServiceRedirect />
  );
};

export default RequireService;
